export default __webpack_public_path__ + "static/media/accentpos-logo.051af75e.png";